// Explicit report date fields: do not infer date behavior from arbitrary labels.
export const REPORT_DATE_CRITERIA_FIELDS = new Set([
    'cases.create_date',
    'cases.updated_at',
    'cases.phase_date',
    'leads.created_at',
    'leads.updated_at',
    'leads.incident_date',
    'leads.status_date',
    'contacts.date_of_birth',
    'contacts.date_of_death',
    'contacts.created_at',
    'contacts.updated_at',
    'feed_updates.creation_date',
    'deadlines.due',
    'deadlines.done',
    'deadlines.created_at',
]);

export const isReportDateCriteriaField = (field) => {
    const id = String(field?.id ?? '');
    return REPORT_DATE_CRITERIA_FIELDS.has(id)
        || /^item_created_date_\d+$/.test(id)
        || Number(field?.field_id) === 6;
};

export const singleReportDateCriteriaValue = (value, operator) => {
    if (!Array.isArray(value) || !['=', '!=', '<', '<=', '>', '>=', 'LIKE', 'NOT LIKE'].includes(operator)) {
        return value;
    }
    // Switching from a range to a single-date condition keeps its first usable
    // bound. Numeric before/after offsets must not become calendar dates.
    return value.find(date => typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) || '';
};
